export const GROUP = {
  STREAMER: ["STREAMER", "MANAGER"],
  USER: [
    "USER",
    "OTHER_PAID_USER",
    "PAID_USER",
    "FREE_USER",
    "NOT_MATCHED_USER",
  ],
  UNVERIFIED: ["NOT_MATCHED_USER", "ANONYMOUS"],
  UNPAID: ["ANONYMOUS", "FREE_USER", "OTHER_PAID_USER"],
  LOGIN_USER: ["FREE_USER", "PAID_USER", "OTHER_PAID_USER"],
}
